var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { getResponsiveProp } from '../../styles';
import { childrenToElementArray } from '../helpers';
import { inlineBaseStyles, inlineSpaceStyles } from './styles';
var Root = styled.div(inlineBaseStyles, inlineSpaceStyles);
export var Inline = forwardRef(function (props, ref) {
  var childrenProp = props.children,
      spaceProp = props.space,
      restProps = __rest(props, ["children", "space"]);

  var children = childrenToElementArray(childrenProp).filter(Boolean);
  var space = getResponsiveProp(spaceProp, []);
  return React.createElement(Root, Object.assign({
    "data-ui": "Inline"
  }, restProps, {
    ref: ref,
    space: space
  }), children.map(function (child, idx) {
    return React.createElement("div", {
      key: idx
    }, child);
  }));
});
Inline.displayName = 'Inline';